var _ellipse, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoverageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 9.5,
    rx: 9,
    ry: 9.375,
    fill: "#45B549",
    fillOpacity: 0.17
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10251_27842)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99967 5.15974C8.11562 5.15974 7.26777 5.52556 6.64265 6.17673C6.01753 6.8279 5.66634 7.71107 5.66634 8.63197C5.66634 9.97661 6.50623 11.2814 7.42715 12.294C7.8791 12.7909 8.33245 13.1977 8.67329 13.4804C8.80014 13.5856 8.91093 13.6733 8.99967 13.7416C9.08841 13.6733 9.19921 13.5856 9.32606 13.4804C9.6669 13.1977 10.1203 12.7909 10.5722 12.294C11.4931 11.2814 12.333 9.97661 12.333 8.63197C12.333 7.71107 11.9818 6.8279 11.3567 6.17673C10.7316 5.52556 9.88373 5.15974 8.99967 5.15974ZM8.99967 14.2743C8.76855 14.6355 8.76844 14.6354 8.76832 14.6353L8.76713 14.6345L8.76436 14.6325L8.75481 14.6258C8.74669 14.6201 8.73512 14.6118 8.72032 14.6011C8.69073 14.5798 8.6482 14.5487 8.59459 14.5084C8.4874 14.4277 8.33566 14.31 8.15418 14.1595C7.7919 13.859 7.30775 13.4249 6.82219 12.891C5.86812 11.8419 4.83301 10.3255 4.83301 8.63197C4.83301 7.48085 5.27199 6.37688 6.0534 5.56292C6.8348 4.74896 7.89461 4.29169 8.99967 4.29169C10.1047 4.29169 11.1646 4.74896 11.946 5.56292C12.7274 6.37688 13.1663 7.48085 13.1663 8.63197C13.1663 10.3255 12.1312 11.8419 11.1772 12.891C10.6916 13.4249 10.2075 13.859 9.84517 14.1595C9.66369 14.31 9.51195 14.4277 9.40476 14.5084C9.35115 14.5487 9.30862 14.5798 9.27903 14.6011C9.26423 14.6118 9.25266 14.6201 9.24454 14.6258L9.23499 14.6325L9.23222 14.6345L9.23134 14.6351C9.23122 14.6352 9.2308 14.6355 8.99967 14.2743ZM8.99967 14.2743L9.2308 14.6355C9.09084 14.7327 8.90828 14.7325 8.76832 14.6353L8.99967 14.2743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99967 7.76393C8.53944 7.76393 8.16634 8.15257 8.16634 8.63199C8.16634 9.1114 8.53944 9.50004 8.99967 9.50004C9.45991 9.50004 9.83301 9.1114 9.83301 8.63199C9.83301 8.15257 9.45991 7.76393 8.99967 7.76393ZM7.33301 8.63199C7.33301 7.67316 8.0792 6.89587 8.99967 6.89587C9.92015 6.89587 10.6663 7.67316 10.6663 8.63199C10.6663 9.59081 9.92015 10.3681 8.99967 10.3681C8.0792 10.3681 7.33301 9.59081 7.33301 8.63199Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10251_27842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10.4167,
    fill: "white",
    transform: "translate(4 4.29169)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverageIcon);
export default __webpack_public_path__ + "static/media/CoverageIcon.d3224068ca5f7201a2a8906821ecf475.svg";
export { ForwardRef as ReactComponent };